exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".global__filter.show .global__filter__close {\n  display: block;\n}\n.global__filter__close {\n  display: none;\n}\n.global__filter--show {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
